<!-- eslint-disable vue/multi-word-component-names -->
<template>
	<div class="container" v-if="store.group.id">
		<!-- 聊天主窗口 -->
		<div class="box">
			<VideoPlayer :videoUrl="store.dislog.player" v-if="store.dislog.player"></VideoPlayer>
			<!-- <div class="box-bd" id="box-bd" ref="scrollRef" @scroll="handleScroll">
				<div class="message-box" v-for="data in store.comments" :key="data.id">
					<ChatBox :data="data" v-if="store.comments" :user="store.group"/>
				</div>
			</div> -->
			<DynamicScroller class="box-bd" id="box-bd" ref="scrollRef" :items="store.comments" :min-item-size="60" key-field="id" @scroll="handleScroll">
				<template #before>
					<div class="loading-tip">
						<span v-if="!store.hasMore && store.comments.length>20" class="nomore">没有更多了...</span>
						<van-loading size="24px"  v-if="isLoading">加载中...</van-loading>
					</div>
				</template>
				<template v-slot="{ item, index, active }">
				  <DynamicScrollerItem :item="item" :active="active" :size-dependencies="[item.message]" :key="item.id"  >
				    <div class="message-box" > 
				      <ChatBox :data="item"  :user="store.group"  :key="item.id + '-' + item.updatedAt" @scrollBarDirKey="scrollBarDirKey" v-if="active" />
				    </div>
				  </DynamicScrollerItem>
				</template>
			</DynamicScroller>
			<!-- 聊天窗口底部区域 -->
			<div class="last" v-if="store.status==500" style="text-align: center;font-size: 14px;padding: 10px 0;">加入群聊失败</div>
			<div class="box-ft" v-else>
				<!-- 工具栏 -->
				 <!-- {{ store.group.robot?.robotQptplPhrases }} -->
				<SayList @modelsub="modelsub" :list="store.group.robot?.robotQptplPhrases"></SayList>
				<div class="toolbar">
					<div class="content">
						<div class="text" id="content" contenteditable  @keydown="keyDown($event)"></div>
					</div>
					<a href="javascript:void(0);" class="face" @click="handleEmojiClick"></a>
					<a href="javascript:void(0);" class="add" @click="store.visible('tool',!store.dislog.tool)"></a>
					<button href="javascript:void(0);" class="send" @click.stop.prevent="send(false)" @touchend.prevent="send(false)" :disabled="isSend" >发送</button>
				</div>
				<Toolbox  v-if="store.dislog.tool"></Toolbox>
			</div>
			<Emoji v-if="store.dislog.emoji"/>
		</div>
	</div>
</template>
<script setup>
	// 聊天列表   https://kefu.dev.dyuit.cn?token=&wxappId=
	// 详情				https://kefu.dev.dyuit.cn/index?token=&wxappId=&code=D8CF98B29712F797A732ADE928691D80&orderNo=1&goodsId=1
	import Emoji from "@/components/emoji/index"
	import Toolbox from '@/components/tool/index'
	import ChatBox from '@/components/chat/ChatBox'
	import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
	import SayList from "@/components/chat/SayList.vue";
	import { ref, onMounted,nextTick,onUnmounted} from 'vue';
	import { useSocket } from "@/stores/index";
	import { useWork } from "@/stores/work";
	import { sendType } from '@/assets/js/index'
	import { showLoadingToast, closeToast,showToast } from 'vant';
	import VideoPlayer from '@/components/tool/videoPlay.vue'
	import { emojiDirective } from '@/components/emoji/emoji'
	const vEmoji = emojiDirective
	const isSend=ref(false)
	const store=useSocket(),work=useWork()
	import { useScroll } from '@/stores/scroll'
	const scrollStore = useScroll()
	const scrollRef = ref(null)

	const scrollDebounce = ref(null)
	const readMoreDebounce = ref(null)
	const isLoading=ref(false)
	function keyDown (event) {
		if (event.shiftKey && event.keyCode === 13) {
			event.preventDefault();
			document.execCommand('insertParagraph');
			return false;
		}
		document.execCommand('formatblock', false, '<p>');
	}
const handleEmojiClick = () => {
  const editableDiv = document.getElementById('content');
  const isShowingEmoji = !store.dislog.emoji;
  
  // 如果当前键盘是激活状态，点击表情按钮时隐藏键盘
  if (editableDiv && document.activeElement === editableDiv) {
    editableDiv.blur(); // 失去焦点，隐藏键盘
  }
  
  // 切换表情包显示状态
  store.visible('emoji', isShowingEmoji);
}
const scrollBarDirKey=(id)=>{
	const index = store.comments.findIndex(item => item.id === id);
	if (index === -1) return; // 如果没有找到对应的消息，直接返回
	const scrollContainer = scrollRef.value;
  scrollContainer.scrollToItem(index);
}
	async function hiRobot(){
		let res = {
			content:'用户进入聊天',
			groupId: store.group.id,
			type: sendType.ENTER
		};
		await store.sendMess(res,'robot')
	}
	onMounted(async() => {
		store.setComment([])
		try{
			await store.init()
			nextTick(() => {
				if(scrollRef.value?.$el) {
					scrollStore.register(scrollRef.value)
					scrollStore.toBottom() // 初始化后滚动到底部
				}
			})
			//await store.save();
		
			setTimeout(async () => {
				
				if(work.isConnect && work.socket){
				//	await hiRobot()
				}
				const editableDiv = document.getElementById('content');
				if(editableDiv){
					editableDiv.addEventListener('focus', function() {
						store.visible('emoji',false)
					});
				}
			},1000);
			
		}catch(e){
			//alert("加入群聊失败")
		}
	});
	// const robotRobot=computed(()=>{
	// 	return work.robot.robotQptplPhrases
	// })
	const modelsub=(data)=>{
		if(isSend.value){
			return false;
		}
		const { content,action }=data;
		let res = {
			content:content,
			groupId: store.group.id,
			type: action==3?sendType.TRANSFER:sendType.TEXT
		};
		isSend.value=true;
		try{
			store.sendMess(res).then(()=>{
				isSend.value=false;
			})
		}
		catch{
			this.isSend=false
		}
	}
	const handleScroll = async () => {
		if (!store.hasMore || isLoading.value) return
		if (scrollDebounce.value) clearTimeout(scrollDebounce.value)
		const scrollContainer = scrollRef.value.$el
		const currentScrollTop = scrollContainer.scrollTop
		scrollDebounce.value = setTimeout(async () => {
			if (currentScrollTop < 100) { // 增大触发阈值
				isLoading.value = true
				try {
					await readMore()
				} 
				catch (error)  {
					isLoading.value = false
				}
			}
		}, 300) // 延长防抖时间
	}
	const readMore = async () => {
		if (readMoreDebounce.value) clearTimeout(readMoreDebounce.value)	
		readMoreDebounce.value = setTimeout(async () => {
			if (store.comments.length === 0) return
			const scrollContainer = scrollRef.value.$el
			const prevScrollTop = scrollContainer.scrollTop
			const prevScrollHeight = scrollContainer.scrollHeight			
			const list = await store.getHistory({ minId: store.comments[0].id }) || []
			if (list.length === 0) return
			store.setComment([...list, ...store.comments])
			nextTick(() => {
				const newScrollHeight = scrollContainer.scrollHeight
				scrollContainer.scrollTop = prevScrollTop + (newScrollHeight - prevScrollHeight)
				isLoading.value = false
			})
		}, 200)
	}

	const send =async (val) => {	//发送消息
		if(isSend.value){
			showLoadingToast({
				duration: 0,
				forbidClick: true,
				message: '正在发送中...',
			});
			return false;
		}
		const dom=document.getElementById("content")
		if (!dom.innerHTML && !val) return;
		let contentWithEmojiSymbols = dom.innerHTML;
  
		const customEmojiConfig = await import('@/components/emoji/customEmojiConfig.json');
		const emojiMap = {};
		
		// 适配对象格式的表情配置文件 - 直接使用配置对象
		const customEmojis = customEmojiConfig.default.customEmojis;
		for (const symbol in customEmojis) {
			if (customEmojis.hasOwnProperty(symbol)) {
				const filename = customEmojis[symbol];
				emojiMap[filename] = symbol; // 构建从filename到symbol的反向映射
			}
		}
		
		// 查找所有表情图片并替换回原始符号
		// 先处理带有data-emoji-pattern属性的图片（这些是被emoji directive处理过的）
		const imgTagsWithPattern = contentWithEmojiSymbols.match(/<img[^>]*data-emoji-pattern="([^"]*)"[^>]*>/g);
		if (imgTagsWithPattern) {
			imgTagsWithPattern.forEach(imgTag => {
				// 提取原始表情符号
				const match = imgTag.match(/data-emoji-pattern="([^"]*)"/);
				if (match && match[1]) {
					const originalSymbol = match[1];
					contentWithEmojiSymbols = contentWithEmojiSymbols.replace(imgTag, originalSymbol);
				}
			});
		}
		
		// 然后处理普通的表情图片（根据文件名匹配）
		for (const filename in emojiMap) {
			if (emojiMap.hasOwnProperty(filename)) {
				const symbol = emojiMap[filename];
				// 匹配包含对应文件名的表情图片标签
				const imgRegex = new RegExp(`<img[^>]*src="[^"]*${filename.replace(/\./g, '\\.')}"[^>]*>`, 'g');
				
				contentWithEmojiSymbols = contentWithEmojiSymbols.replace(imgRegex, symbol);
			}
		}
		let res = {
			content:contentWithEmojiSymbols,
			groupId: store.group.id,
			type: sendType.TEXT
		};
		try{
			isSend.value=true;
			store.sendMess(res).then(()=>{
				dom.innerHTML = " "
				isSend.value=false;
				closeToast();
			})
		}
		catch{
			showToast('发送失败，请稍后再试！')
			// setTimeout(()=>{

			// },1000)
		}
	}
	onUnmounted(() => {
		if(scrollDebounce.value) clearTimeout(scrollDebounce.value)
		if(readMoreDebounce.value) clearTimeout(readMoreDebounce.value)
	})
</script>
<style lang="scss">
	
	.errmess{
		height: 300px;
		overflow: auto;
	}
	.v3-footer{
		display: none!important;
	}
	.comments-list {
		margin-top: 20px;
		.comments-list-item {
			margin-bottom: 20px;
			.comments-list-item-heading {
				display: inline-block;
				img {
					height: 32px;
					width: 32px;
					border-radius: 50%;
					vertical-align: middle;
				}
				.comments-list-item-username {
					margin-left: 5px;
					font-weight: bold;
				}
			}
			.comments-list-item-content {
				margin: 10px 0px;
				border-bottom: 1px solid #cccccc;
				&:last-child {
					border-bottom: 0;
				}
				span {
					vertical-align: top;
				}
			}
		}
	}
</style>
